export const FareCalculator = (distance, rateDetails, instructionData, decimal) => {
    const MIN_FARE_DISTANCE_LIMIT = 3; // Minimum ücretin geçerli olduğu maksimum mesafe (KM)

    let baseCalculated = (parseFloat(rateDetails.rate_per_unit_distance) * parseFloat(distance));
    if (rateDetails.base_fare > 0) {
        baseCalculated = baseCalculated + rateDetails.base_fare;
    }
    if (instructionData && instructionData.parcelTypeSelected) {
        baseCalculated = baseCalculated + instructionData.parcelTypeSelected.amount;
    }
    if (instructionData && instructionData.optionSelected) {
        baseCalculated = baseCalculated + instructionData.optionSelected.amount;
    }

    let subtotal;
    if (parseFloat(distance) <= MIN_FARE_DISTANCE_LIMIT) {
        // 3 KM ve altı için minimum ücret uygulanır, ama parcel ve option ücretleri de eklenir
        let minFareBase = rateDetails.min_fare + rateDetails.base_fare;
        let parcelAndOptionFees = 0;
        if (instructionData && instructionData.parcelTypeSelected) {
            parcelAndOptionFees += instructionData.parcelTypeSelected.amount;
        }
        if (instructionData && instructionData.optionSelected) {
            parcelAndOptionFees += instructionData.optionSelected.amount;
        }
        subtotal = minFareBase + parcelAndOptionFees;
    } else {
        // 3 KM üzeri için mesafe çarpanı ve açılış ücreti ile hesaplanır, minimum ücret uygulanmaz
        subtotal = baseCalculated + rateDetails.min_fare;
    }
    
    let convenienceFee = 0;
    if (rateDetails.convenience_fee_type && rateDetails.convenience_fee_type == 'flat') {
        convenienceFee = rateDetails.convenience_fees;
    } else {
        convenienceFee = (subtotal * parseFloat(rateDetails.convenience_fees) / 100);
    }
    
    // Genel toplam (ara toplam + hizmet bedeli)
    let finalGrandTotal = subtotal + convenienceFee;

    return {
        totalCost: parseFloat(subtotal.toFixed(decimal)), // Ara Toplam (Ücret)
        convenience_fees: parseFloat(convenienceFee.toFixed(decimal)), // Hizmet Bedeli
        grandTotal: parseFloat(finalGrandTotal.toFixed(decimal)) // Genel Toplam
    }
}
